import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMcdonalds = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#D52B1E",
			d: "M9.09.339a1.39 1.39 0 0 1 1.82 0l.692.599c.337.29.79.403 1.223.303l.89-.206a1.394 1.394 0 0 1 1.61.85l.337.855a1.4 1.4 0 0 0 .943.84l.883.234a1.404 1.404 0 0 1 1.033 1.506l-.096.914c-.047.444.12.883.447 1.184l.674.62a1.41 1.41 0 0 1 .219 1.817l-.507.765a1.41 1.41 0 0 0-.152 1.258l.31.864a1.41 1.41 0 0 1-.644 1.711l-.802.44c-.39.213-.655.6-.716 1.042l-.124.911a1.4 1.4 0 0 1-1.361 1.214l-.913.014a1.4 1.4 0 0 0-1.115.589l-.53.748c-.4.565-1.151.75-1.766.438l-.816-.415a1.39 1.39 0 0 0-1.259 0l-.815.415a1.39 1.39 0 0 1-1.766-.438l-.53-.748a1.4 1.4 0 0 0-1.115-.59l-.913-.013a1.4 1.4 0 0 1-1.361-1.214l-.124-.91a1.4 1.4 0 0 0-.716-1.043l-.802-.44a1.41 1.41 0 0 1-.645-1.711l.311-.865a1.41 1.41 0 0 0-.152-1.257l-.507-.765a1.41 1.41 0 0 1 .22-1.817l.674-.62a1.41 1.41 0 0 0 .446-1.184l-.096-.914a1.404 1.404 0 0 1 1.033-1.506l.883-.234c.43-.114.78-.425.943-.84l.337-.855a1.394 1.394 0 0 1 1.61-.85l.89.206c.432.1.886-.012 1.223-.303z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 7.5,
			fill: "#F1BB00"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 6.563,
			fill: "#D52B1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F1BB00",
			fillRule: "evenodd",
			d: "M14.683 13.41c-.041-2.008-.365-3.94-.91-5.44-.551-1.512-1.239-2.345-1.935-2.345-.433 0-.84.315-1.21.937-.229.385-.442.892-.627 1.488-.187-.596-.4-1.103-.629-1.488q-.557-.935-1.21-.937c-.696 0-1.383.833-1.934 2.344-.546 1.5-.87 3.433-.91 5.44l-.005.236h1.399l.002-.228c.055-4.194 1.054-6.853 1.46-6.853.275 0 .975 1.841 1.081 6.401l.006.225h1.479l.005-.225c.106-4.56.807-6.402 1.081-6.402.407 0 1.406 2.66 1.46 6.854l.003.228h1.399z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F1BB00",
			fillRule: "evenodd",
			d: "M14.577 13.412c-.04-1.996-.362-3.915-.905-5.405-.525-1.445-1.194-2.274-1.834-2.274-.701 0-1.361.974-1.837 2.69-.477-1.716-1.137-2.69-1.838-2.69-.64 0-1.31.83-1.835 2.274-.542 1.49-.864 3.409-.905 5.405l-.002.124h1.186l.001-.12c.056-4.25 1.06-6.961 1.566-6.961.435 0 1.088 2.261 1.187 6.508l.003.119h1.272l.003-.12c.099-4.245.753-6.507 1.187-6.507.507 0 1.511 2.71 1.566 6.96l.002.121h1.186z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F1BB00",
			fillRule: "evenodd",
			d: "M8.15 6.095v.24c-.692.072-1.61 3.166-1.661 7.08l-.47-.482v-.012c.149-3.838 1.195-6.795 2.13-6.826",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F1BB00",
			fillRule: "evenodd",
			d: "M8.125 5.857h.08C8.9 5.904 9.56 7.08 10 8.895v3.51c-.171-3.625-.933-6.31-1.835-6.31-.186 0-.376.116-.564.333V6.09q.265-.216.525-.233m4.027.345v.336q-.168-.203-.326-.205c-.668 0-1.22 2.885-1.306 6.627l-.52-.531v-.009c.17-3.632.934-6.326 1.836-6.326q.157 0 .316.108",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F1BB00",
			fillRule: "evenodd",
			d: "M14.456 13.358v.055l-.471-.483-.002.002c-.138-3.561-1.048-6.368-1.925-6.784v-.255c1.124.372 2.307 3.523 2.398 7.465",
			clipRule: "evenodd"
		})
	]
});
const ForwardRef = forwardRef(SvgMcdonalds);
export default ForwardRef;
